import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import EventNoteIcon from "@mui/icons-material/EventNoteRounded";
import { MetaIcons } from "../../../../../../api/types/svTypes";
import FunctionIcon from "@entrilia/shared/icons/FunctionIcon";
import HashIcon from "@entrilia/shared/icons/HashIcon";
import SigmaIcon from "@entrilia/shared/icons/SigmaIcon";

const MetaIcon = ({ icon }: { icon: MetaIcons }) => {
  switch (icon) {
    case MetaIcons.Hash:
      return <HashIcon />;
    case MetaIcons.Calendar:
      return <EventNoteIcon />;
    case MetaIcons.Sigma:
      return <SigmaIcon />;
    case MetaIcons.Function:
      return <FunctionIcon />;
    case MetaIcons.CustomCalculation:
      return <CalculateOutlinedIcon />;
    default:
      return <SigmaIcon />;
  }
};

export default MetaIcon;
